// extracted by mini-css-extract-plugin
export default {"container":"index_container__Wu300","tableBody":"index_tableBody__RsOD+","tableHeader":"index_tableHeader__wWXRy","opWrap":"index_opWrap__W3Q7y","tableSpin":"index_tableSpin__e-o35"};